import { createAction } from 'redux-actions';

export const GetListEventOfOrganizerRequested = createAction('GET_LIST_EVENT_OF_ORGANIZER_REQUESTED');
export const GetListEventOfOrganizerRequestedReceived = createAction('GET_LIST_EVENT_OF_ORGANIZER_REQUESTED_RECEIVED');
export const GetListEventOfOrganizerRequestedReceivedFailure = createAction('GET_LIST_EVENT_OF_ORGANIZER_REQUESTED_RECEIVED_FAILURE');
export const ClearListEventOfOrganizer = createAction('CLEAR_LIST_EVENT_OF_ORGANIZER');

export const GetDetailOfOrganizerRequested = createAction('GET_DETAIL_OF_ORGANIZER_REQUESTED');
export const GetDetailOfOrganizerRequestedReceived = createAction('GET_DETAIL_OF_ORGANIZER_REQUESTED_RECEIVED');
export const GetDetailtOfOrganizerRequestedReceivedFailure = createAction('GET_DETAIL_OF_ORGANIZER_REQUESTED_RECEIVED_FAILURE');
export const ClearGetDetailOfOrganizer = createAction('CLEAR_GET_DETAIL_OF_ORGANIZER');

export const ApproveRegisterRequested = createAction('APPROVE_REGISTER_REQUESTED');
export const ApproveRegisterRequestedReveived = createAction('APPROVE_REGISTER_REQUESTED_RECEIVED');
export const ApproveRegisterRequestedReveivedFailure = createAction('APPROVE_REGISTER_REQUESTED_RECEIVED_FAILURE');
export const ClearApprovedRegister = createAction('CLEAR_APPROVE_REGISTER');

export const RejectRegisterRequested = createAction('REJECT_REGISTER_REQUESTED');
export const RejectRegisterRequestedReveived = createAction('REJECT_REGISTER_REQUESTED_RECEIVED');
export const RejectRegisterRequestedReveivedFailure = createAction('REJECT_REGISTER_REQUESTED_RECEIVED_FAILURE');
export const ClearRejectedRegister = createAction('CLEAR_REJECTED_REGISTER');

export const SendInvoiceRequested = createAction('SEND_INVOICE_REQUESTED');
export const SendInvoiceRequestedReveived = createAction('SEND_INVOICE_REQUESTED_RECEIVED');
export const SendInvoiceRequestedReveivedFailure = createAction('SEND_INVOICE_REQUESTED_RECEIVED_FAILURE');
export const ClearSendInvoice = createAction('CLEAR_SEND_Invoice');

export const GetCsvOrganizerRequested = createAction('GET_CSV_ORGANIZER_REQUESTED');
export const GetCsvOrganizerRequestedReceived = createAction('GET_CSV_ORGANIZER_REQUESTED_RECEIVED');
export const GetCsvOrganizerReceiveFailure = createAction('GET_CSV_ORGANIZER_REQUESTED_RECEIVE_FAILURE');
export const GetCsvOrganizerClear = createAction('GET_CSV_ORGANIZER_CLEAR');
